import React, { useState, useMemo, useEffect } from 'react';
import './CreateUsersPage.css';
import { Button, Text, Grid, Col, Title, TextInput, Dropdown, DropdownItem, Card } from "@tremor/react";
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import { User } from '../../interfaces/AccessInterfaces';
import SidebarComponent from '../../components/SidebarComponent';
import TitleComponent from "../../components/TitleComponent";
import { validateCPF } from '../../utils/validaCpf';
import { Prices } from '../../interfaces/FinanceInterface';

export default function CreateUsersPage() {
  const [cookies] = useCookies(['mazelog-user']);
  const token = cookies['mazelog-user']?.token_data?.access_token
  const oauth = "Bearer " + token
  const orgId = cookies["mazelog-user"]?.organization_data?.id_org;
  
  const baseURLAuth = process.env.REACT_APP_MAZELOG_AUTH_BASE_URL;
  const baseURL = process.env.REACT_APP_MAZELOG_SYSTEM_BASE_URL;

  const baseUser = {
    username: "",
    id_org: 1,
    user_profile: "TRANSPORTER",
    email: "",
    password: "",
    active: true,
    full_name: "",
    cpf: "",
    phone: ""
  }

  const [requestProcessing, setRequestProcessing] = useState(false);
  const [user, setUser] = useState<User>(baseUser);
  const [cpfError, setCpfError] = useState<string | null>(null);
  const [priceUser, setPriceUser] = useState("");
  const [prices, setPrices] = useState<Prices[]>([]);

  const navigate = useNavigate();

  const hasPriceTable = useMemo(()=> {
      return false // user?.user_profile === "CLIENT" || user?.user_profile === "TRANSPORTER" || user?.user_profile === "TRANSPORTER_COLLECTER"
  }, [user]) 

  const handleGetPrices = () => {
    const oauth = "Bearer " + token;
    axios
      .get(`${baseURL}/prices/?org_id=${orgId}`, { headers: { accept: "application/json", Authorization: oauth } })
      .then((res) => {
        if (res.data != null) {
          setPrices(res.data.results);
        }
      })
      .catch((err) => console.log(err));
  };


  const createUser = async () => {
    if (cpfError) {
      alert('Por favor, corrija o CPF antes de prosseguir.');
      return;
    }
    try {


      // Limpar a formatação do telefone
      const userClean = { ...user };
      userClean.phone = userClean.phone?.replace(/[^\d]/g, '');
        console.log(userClean.id_user)
      // setRequestProcessing(true);
  
      await axios.post(`${baseURLAuth}/users`, userClean, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": oauth,
      }});
  
      // // Criar relacionamento entre usuário e preço
      // if (priceUser) {
      //   const body = {
      //     id_user: userClean.id_user,
      //     id_price: priceUser,
      //   };
    
      //   await axios.post(`${baseURL}/prices/user/`, body, {
      //     headers: {
      //       accept: "application/json",
      //       Authorization: oauth,
      //     },
      //   });
      // }

      // navigate('/access');
    }  catch (error) {
      console.error("Erro na criar do usuário:", error);
      alert("Erro ao criar o usuário. Verifique os dados e tente novamente.");
    } finally {
      setRequestProcessing(false);
    }
  }
  
  const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  const phoneValue = e.target.value.replace(/\D/g, ''); // Remove tudo que não for número
  let maskedPhone = '';

  if (phoneValue.length > 10) {
    // Com código de país (exemplo: 55 11 96467-7742)
    maskedPhone = phoneValue
      .replace(/^(\d{2})(\d{2})(\d{4,5})(\d{4})$/, '($1) $2 $3-$4');
  } else {
    // Sem código de país (exemplo: 11 96467-7742)
    maskedPhone = phoneValue
      .replace(/^(\d{2})(\d{4,5})(\d{4})$/, '($1) $2-$3');
  }

  setUser({ ...user, phone: maskedPhone });
};

  
  const handleCpfChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const cpf = e.target.value.replace(/\D/g, '');
    setUser({ ...user, cpf });
    setCpfError(validateCPF(cpf) ? null : 'CPF inválido.');
  };

  useEffect(()=>{
    handleGetPrices();
  },[]) 

  return (
    <main className="Page">
      <SidebarComponent />
      <div className="Content">
        <TitleComponent />
        <div className="CreateUserViews">
            <Card>
                <Title>Criar usuário</Title>
                <Grid numCols={1} className="gap-2">
                    <Col numColSpan={1}>
                        <Text>ID Organização</Text>
                        <TextInput 
                        className='max-w-md'
                        onChange={(e) => {setUser({...user, id_org: parseInt(e.target.value)})}}
                        />
                    </Col>
                    <Col numColSpan={1}>
                        <Text>Username</Text>
                        <TextInput 
                        className='max-w-md'
                        onChange={(e) => {setUser({...user, username: e.target.value})}}
                        />
                    </Col>
                    <Col numColSpan={1}>
                        <Text>Nome completo</Text>
                        <TextInput 
                        className='max-w-md'
                        onChange={(e) => {setUser({...user, full_name: e.target.value})}}
                        />
                    </Col>
                    <Col numColSpan={1}>
                        <Text>Email</Text>
                        <TextInput
                        className='max-w-md'
                        onChange={(e) => {setUser({...user, email: e.target.value})}}
                        />
                    </Col>
                    <Col numColSpan={1}>
                        <Text>Senha</Text>
                        <TextInput
                        className='max-w-md'
                        onChange={(e) => {setUser({...user, password: e.target.value})}}
                        />
                    </Col>
                    <Col numColSpan={1}>
                        <Text>CPF</Text>
                        <TextInput 
                        className='max-w-md'
                        value={user.cpf}
                        onChange={handleCpfChange}
                        />
                        {cpfError && <Text className="text-red-500">{cpfError}</Text>}
                    </Col>
                    <Col numColSpan={1}>
                        <Text>Phone</Text>
                        <TextInput 
                        className='max-w-md'
                        value={user.phone}
                        onChange={handlePhoneChange}
                        />
                    </Col>
                    <Col>
                        <Text>Perfil</Text>
                        <Dropdown
                        className='max-w-md'
                        defaultValue="TRANSPORTER"
                        onValueChange={ (value) => {setUser({...user,user_profile:value}); setPriceUser('') } }
                        >
                        <DropdownItem value="ADMIN" text="ADMIN" />
                        <DropdownItem value="EMPLOYEE" text="EMPLOYEE" />
                        <DropdownItem value="CLIENT" text="CLIENT" />
                        <DropdownItem value="TRANSPORTER" text="TRANSPORTER" />
                        <DropdownItem value="TRANSPORTER_COLLECTER" text="TRANSPORTER_COLLECTER" />
                        </Dropdown>
                    </Col>

                  { hasPriceTable && (
                    <Col>
                      <Text>Tabela de Preço</Text>
                      <Dropdown
                        className="max-w-md"
                        defaultValue={priceUser}
                        onValueChange={(value) => setPriceUser(value)}
                      >
                        {prices.map((item) => (
                          <DropdownItem key={item._id} value={item._id ?? "-"} text={item.title} />
                        ))}
                      </Dropdown>
                  </Col>
                  )}

                </Grid>
            <Button
            disabled={requestProcessing}
            onClick={createUser}
            className='CreateUserBtn'
            > Criar </Button>
            </Card>
        </div>
      </div>
    </main>
  );
}